import ClientParameter from './containers/ClientParameterView';

import React from 'react';


export default ClientParameter;

export {serverDataClientParameters} from './reducers/ClientParametersView';